import { Product } from 'constants/product';

export interface ProductMeta {
  defaultTitle: string;
  defaultDescription: string;
  loginTitle: string;
  loginDescription: string;
  signupTitle: string;
  signupDescription: string;
}

type ProductsMetaType = {
  [key in Product]: ProductMeta;
};

export const productsMeta: ProductsMetaType = {
  [Product.LiveChat]: {
    defaultTitle: 'LiveChat | Connect with customers',
    defaultDescription:
      'Use your LiveChat account and start chatting with your website visitors and customers.',
    loginTitle: 'Sign In to Your LiveChat Account | Text Accounts',
    loginDescription:
      'Log in to your LiveChat account. Sign in securely and efficiently manage customer support chats.',
    signupTitle: 'LiveChat Sign Up | Create Live Chat Account | Text Accounts',
    signupDescription:
      'Try LiveChat for free - register your LiveChat trial and start chatting with your website visitors and customers.',
  },
  [Product.HelpDesk]: {
    defaultTitle: 'HelpDesk | Support customers with tickets',
    defaultDescription:
      'Use your HelpDesk account and solve customer cases with a ticketing system.',
    loginTitle: 'Sign In to Your HelpDesk Account | Text Accounts',
    loginDescription:
      'Log in to your HelpDesk account. Sign in securely and solve customer support tickets efficiently.',
    signupTitle: 'Sign Up | Register HelpDesk Account | Text Accounts',
    signupDescription:
      'Try HelpDesk for free - start your help desk software trial and solve customer cases with a ticketing system.',
  },
  [Product.KnowledgeBase]: {
    defaultTitle: 'KnowledgeBase | Improve support with self-service',
    defaultDescription:
      'Use your KnowledgeBase account and start educating your team and customers with a self-service platform.',
    loginTitle: 'Sign In to Your KnowledgeBase Account | Text Accounts',
    loginDescription:
      'Log in to your KnowledgeBase account. Sign in securely and create effortless self-service articles.',
    signupTitle: 'Sign Up | Register KnowledgeBase Account | Text Accounts',
    signupDescription:
      'Try KnowledgeBase for free - register your knowledge base account and start educating your team and customers with a self-service platform.',
  },
  [Product.ChatBot]: {
    defaultTitle: 'ChatBot | Automate customer service with AI',
    defaultDescription: 'Use your ChatBot account and start automating your customer interactions.',
    loginTitle: 'Sign In to Your ChatBot Account | Text Accounts',
    loginDescription:
      'Log in to your ChatBot account to access the dashboard. Sign in securely and automate customer support.',
    signupTitle: 'ChatBot Sign Up | Create AI bot | Text Accounts',
    signupDescription:
      'Try ChatBot for free - register your AI chatbot trial and start automating your customer interactions.',
  },
  [Product.OpenWidget]: {
    defaultTitle: 'OpenWidget | Enhance websites with widgets',
    defaultDescription:
      'Use your OpenWidget account and start engaging your customers with powerful web widgets.',
    loginTitle: 'Sign In to Your OpenWidget Account | Text Accounts',
    loginDescription:
      'Log in to your OpenWidget account. Sign in securely and efficiently engage customers with powerful web widgets.',
    signupTitle: 'Sign Up | Register OpenWidget Account | Text Accounts',
    signupDescription:
      'Try OpenWidget for free - register your OpenWidget account and start engaging your customers with powerful web widgets.',
  },
  [Product.Platform]: {
    defaultTitle: 'Text Platform | Build and monetize automation tools',
    defaultDescription:
      'Use your Text Platform account and start building apps and generating income with customer support solutions.',
    loginTitle: 'Sign In to Your Text Platform Account | Text Accounts',
    loginDescription:
      'Log in to your Text Platform account. Sign in securely and quickly build communication apps.',
    signupTitle: 'Sign Up | Register Text Platform Account | Text Accounts',
    signupDescription:
      'Join Text Platform for free - register your Text Platform account and start building apps and generating income with customer support solutions.',
  },
  [Product.TeamChat]: {
    defaultTitle: 'TeamChat | Improve team communication',
    defaultDescription:
      'Use your TeamChat account and start communicating with your colleagues and team members.',
    loginTitle: 'Sign In to Your TeamChat Account | Text Accounts',
    loginDescription:
      'Log in to your TeamChat account. Sign in securely and quickly communicate with your colleagues and team members.',
    signupTitle: 'Sign Up | Register TeamChat Account | Text Accounts',
    signupDescription:
      'Try TeamChat for free - register your TeamChat account and start communicating with your colleagues and team members.',
  },
  [Product.PartnerProgram]: {
    defaultTitle: 'Text Partner Program | Perfect for solution providers',
    defaultDescription:
      'Use your Text Partner Program account to make money and earn commissions selling customer service and automation tools.',
    loginTitle: 'Sign In to Your Text Partner Program Account | Text Accounts',
    loginDescription:
      'Log in to your Text Partner Program account. Sign in securely and make money online with affiliate and partner programs.',
    signupTitle: 'Sign up | Register Text Partner Program Account | Text Accounts',
    signupDescription:
      'Join the Text Partner Program - affiliate program built to make money and earn commissions selling customer service and automation tools.',
  },
  [Product.Accounts]: {
    defaultTitle: 'Text Accounts | Hire Text Suite',
    defaultDescription:
      'Hire Text Suite to scale, automate and improve the efficiency of your business.',
    loginTitle: 'Sign In to Your Text Account | Text Accounts',
    loginDescription:
      'Log in to your Text account. Sign in securely and manage your Text products.',
    signupTitle: 'Sign up | Register Text Account | Text Accounts',
    signupDescription:
      'Explore Text products - sign up for free and hire Text Suite to scale, automate and improve the efficiency of your business.',
  },
  // Undefined case contains version for LC - when company will switch to text.com domain, it should be changed to the same as for Accounts
  [Product.Undefined]: {
    defaultTitle: 'LiveChat | Connect with customers',
    defaultDescription:
      'Use your LiveChat account and start chatting with your website visitors and customers.',
    loginTitle: 'Sign In to Your LiveChat Account | Text Accounts',
    loginDescription:
      'Log in to your LiveChat account. Sign in securely and efficiently manage customer support chats.',
    signupTitle: 'LiveChat Sign Up | Create Live Chat Account | Text Accounts',
    signupDescription:
      'Try LiveChat for free - register your LiveChat trial and start chatting with your website visitors and customers.',
  },
};
